import React from "react";

/**
 * Brand-colored OTA tiles. We use stable brand colors + inline marks
 * (not third-party CDNs that may rate-limit or break in offline preview).
 * Each tile is a controlled visual identity, not a copyrighted logo asset.
 */
const OTAS = [
  {
    name: "Booking.com",
    bg: "#003580",
    mark: <span className="font-display text-base font-extrabold text-white">B<span className="text-[#FEBA02]">.</span></span>,
  },
  {
    name: "Airbnb",
    bg: "#FF5A5F",
    mark: (
      <svg viewBox="0 0 32 32" className="h-5 w-5 fill-white" aria-hidden>
        <path d="M16 2c-3 0-5 2.2-6.8 5.4C5.1 14.7 2 21.7 2 25c0 3 2.2 5 5 5 2.4 0 4.7-1.6 9-7 4.3 5.4 6.6 7 9 7 2.8 0 5-2 5-5 0-3.3-3.1-10.3-7.2-17.6C20 4.2 18 2 16 2zm0 4c1 0 2.4 1.3 3.8 3.9 3.9 6.7 6.2 13.3 6.2 15.1 0 1.2-.7 2-2 2-1.4 0-3.2-1.4-8-7.6-4.8 6.2-6.6 7.6-8 7.6-1.3 0-2-.8-2-2 0-1.8 2.3-8.4 6.2-15.1C13.6 7.3 15 6 16 6z" />
      </svg>
    ),
  },
  {
    name: "Expedia",
    bg: "#FFC72C",
    text: "#191E3B",
    mark: <span className="font-display text-base font-extrabold tracking-tight" style={{ color: "#191E3B" }}>EX</span>,
  },
  {
    name: "Agoda",
    bg: "#5392F9",
    mark: (
      <svg viewBox="0 0 32 32" className="h-5 w-5" aria-hidden>
        <circle cx="16" cy="16" r="12" fill="#fff" />
        <circle cx="16" cy="16" r="5" fill="#5392F9" />
        <circle cx="22" cy="22" r="3" fill="#FF6F00" />
      </svg>
    ),
  },
  {
    name: "Google Hotels",
    bg: "#FFFFFF",
    border: "#E2E8F0",
    mark: (
      <svg viewBox="0 0 32 32" className="h-5 w-5" aria-hidden>
        <path fill="#4285F4" d="M16 14v4.4h6.2c-.3 1.4-1 2.6-2.1 3.4l3.5 2.7c2-1.9 3.2-4.6 3.2-7.8 0-.7-.1-1.5-.2-2.2H16z" />
        <path fill="#34A853" d="M9 18.7l-.8.6L5.4 21.6C7.2 25.3 11.3 28 16 28c2.7 0 4.9-.9 6.6-2.4l-3.5-2.7c-1 .6-2.2 1-3.1 1-2.4 0-4.5-1.6-5.2-3.8z" />
        <path fill="#FBBC05" d="M5.4 10.4C4.5 12.1 4 14 4 16s.5 3.9 1.4 5.6L9 18.7c-.2-.6-.4-1.3-.4-2s.2-1.4.4-2L5.4 10.4z" />
        <path fill="#EA4335" d="M16 8.9c1.5 0 2.8.5 3.9 1.5l2.9-2.9C20.9 5.7 18.7 4.8 16 4.8c-4.7 0-8.8 2.7-10.6 6.6L9 14.3c.7-2.2 2.8-3.8 5.2-3.8z" />
      </svg>
    ),
  },
  {
    name: "Vrbo",
    bg: "#FFFFFF",
    border: "#E2E8F0",
    mark: <span className="font-display text-base font-extrabold tracking-tight" style={{ color: "#245ABF" }}>vrbo</span>,
  },
  {
    name: "Hotelbeds",
    bg: "#0E2A47",
    mark: <span className="font-display text-base font-extrabold tracking-tight text-white">h</span>,
  },
  {
    name: "API e Hapur",
    bg: "#0F172A",
    mark: (
      <svg viewBox="0 0 32 32" className="h-5 w-5" aria-hidden>
        <path d="M11 8l-6 8 6 8M21 8l6 8-6 8" fill="none" stroke="#FF9A3D" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export default function OTAList({ compact = false }) {
  return (
    <div
      className={`grid gap-3 ${compact ? "grid-cols-2 sm:grid-cols-4" : "grid-cols-2 sm:grid-cols-4 lg:grid-cols-4"}`}
      data-testid="ota-list"
    >
      {OTAS.map((o) => (
        <div
          key={o.name}
          className="flex items-center gap-3 rounded-lg border border-line bg-white px-3 py-2.5"
        >
          <span
            className="grid h-9 w-9 shrink-0 place-items-center rounded-md"
            style={{
              background: o.bg,
              border: o.border ? `1px solid ${o.border}` : undefined,
            }}
          >
            {o.mark}
          </span>
          <div className="min-w-0 leading-tight">
            <div className="truncate text-sm font-semibold text-ink">{o.name}</div>
            <div className="text-[11px] text-slate2">Sinkron 2-drejtimsh</div>
          </div>
        </div>
      ))}
    </div>
  );
}
